import { api } from "./api";

const uamService = {
  /**
   * Build query string (optional filters)
   */
  _buildQueryString(filters = {}) {
    const params = new URLSearchParams();

    if (filters.page) params.append("page", filters.page);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.search) params.append("search", filters.search);

    const queryString = params.toString();
    return queryString ? `?${queryString}` : "";
  },

  /**
   * ✅ Get all users
   */
  async getAllUsers(filters = {}) {
    const queryString = this._buildQueryString(filters);
    const response = await api.get(`/users${queryString}`);
    return response?.data;
  },

  /**
   * ✅ Add new user
   */
  async addUser(userData) {
    const response = await api.post(`/users`, userData);
    return response?.data;
  },

  /**
   * ✅ Update user (optional - future use)
   */
  async updateUser(id, userData) {
    const response = await api.put(`/user/${id}`, userData);
    return response?.data;
  },

  /**
   * ✅ Delete user (optional - future use)
   */
  async deleteUser(id) {
    const response = await api.delete(`/user/${id}`);
    return response?.data;
  }
};

export default uamService;